export enum EditMode {
    'SAVED' = 0, // initial state
    'EDITING' = 1, // editing
    'SAVING' = 2 // transitory state
}
